<template>
     <div class="tag">
       <span>{{ name }}</span>
     </div>
   </template>
   
   <script>
   export default {
     name: "SearchTag",
     props: {
       name: {
         type: String,
         required: true
       }
     }
   };
   </script>
   
   <style scoped>
   .tag {
     display: inline-flex;
     align-items: center;
     justify-content: center;
     background: linear-gradient(to bottom, #4a90e2, #3867ae);
     color: #ffffff;
     font-weight: 500;
     font-size: 0.85rem;
     padding: 0.35rem 0.75rem;
     border-radius: 999px;
     box-shadow: 0 2px 6px rgba(56, 103, 174, 0.2);
     transition: all 0.25s ease;
     user-select: none;
   }
   
   .tag:hover {
     transform: translateY(-2px);
     box-shadow: 0 4px 10px rgba(56, 103, 174, 0.3);
   }
   
   .tag span {
     line-height: 1;
     letter-spacing: 0.3px;
     color: #ffffff;
   }
   </style>
   